import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { IHearingDate } from '../../shared/classes/hearing-date';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';



@Component({
  selector: 'hearing-date',
  templateUrl: './hearing-date.component.html',
})

export class HearingDateComponent implements OnInit {

    hearingDateList: IHearingDate[];
    allHearingDateList: IHearingDate[];
    myHearing: IHearingDate;
    myDate: Date;
    boardMemberList: any[];
    meetingLocationList: any[];
    userType = '';

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        editHearingDiv: false,
        newHearingDiv: false,
        saveDisabled: false
    };

    isNewEntry: boolean = false;

    filterOptions: any = {
        filterText: '',
    };

    hasRequiredData: boolean = true;

    futureHearingOnly = true;

    constructor(private messageService: MessageService, private schedService: ScheduleService, private confirmationService: ConfirmationService, private datePipe: DatePipe) { }

    ngOnInit() {
        this.displayState.gridDiv = false;
        this.displayState.newHearingDiv = false;
        this.displayState.editHearingDiv = false;
        this.getHearingDates();
        this.getBoardMembers();
        this.getMeetingLocations();
    }

    // returns an object (i.e. instance of IHearingDate)
    createNewHearing():IHearingDate {
        var newHearing: IHearingDate;
        newHearing = {
            id: 0,
            hearingDate: null,
            hearingTime: null,
            boardNumber: '',
            comment: '',
            meetingLocation: {
                id: 0,
                location: '',
                location2: '',
            },
            boardMembers: [
                {
                    id: 0,
                    memberName: '',
                    email: '',
                    phone: ''
                },
                {
                    id: 0,
                    memberName: '',
                    email: '',
                    phone: ''
                },
                {
                    id: 0,
                    memberName: '',
                    email: '',
                    phone: ''
                }
            ],
            meetingLocationId: 0,
            minutesHeader: '',
            minutesFooter: ''

        }
        return newHearing;
    }

    // get list of defined Hearing Dates
    getHearingDates() {
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        this.schedService.getHearingDates().subscribe(data => {
            this.allHearingDateList=[];
            if (data) {
              this.allHearingDateList = data;
              this.hearingDateList = [];
              this.filterOnDate();
                //console.log(data);
            };
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
            this.displayState.newHearingDiv = true;
            this.displayState.editHearingDiv = false;
        });
    }

    filterOnDate(){
      const futureOnly = this.futureHearingOnly;
      const tdy = new Date();
      const baseDate = new Date();
      baseDate.setDate(baseDate.getDate() - 1); // subtract 1 day
      let hearingList = this.allHearingDateList.filter(h => {
        const tHearDt = new Date(h.hearingDate);
        return futureOnly== true &&  tHearDt >= baseDate || futureOnly === false? h : null;
      });
      this.hearingDateList = hearingList;
      // sort it in chronological order
      this.hearingDateList.sort((a, b) => {
        // @ts-ignore
        return new Date(a.hearingDate) - new Date(b.hearingDate);
      });
    }
    // get list of defined Board Members (from dictionary)
    getBoardMembers() {
        this.schedService.getBoardMemberList().subscribe(data => {
            if (data) {
                //console.log(data);
                this.boardMemberList = data;
            }
        })
    }

    // generate comma-delimited list of the Board Members associated w/ a hearing date; used for display in table
    getHearingBM(hearing: IHearingDate): string {
        var tBoardMembers = '';
        var tNum = hearing.boardMembers.length;
        if (hearing.boardMembers.length < 1) { return ''};
        for (let i=0; i < (tNum); i++ ) {
            if (hearing.boardMembers[i].id > 0) {
                if (tBoardMembers === '') {
                    tBoardMembers = hearing.boardMembers[i].memberName;
                } else {
                    tBoardMembers = tBoardMembers + ', ' + hearing.boardMembers[i].memberName;
                }
            }
        }
        return tBoardMembers;
    }

    // get list of defined Meeting Locations (from dictionary)
    getMeetingLocations() {
        this.schedService.getMeetingLocations().subscribe(data => {
            if (data) {
                //console.log(data);
                this.meetingLocationList = data;
            }
        });
    }

    // triggered when user selects a Hearing Date, for editing
    onSelect(hearing: IHearingDate) {
        // get the hearing date's data; from grid or from API call??
        //
        // now, display the edit User form
        //console.log(hearing);
        this.displayState.gridDiv = false;
        this.displayState.newHearingDiv = false;
        this.isNewEntry = false;
        this.myHearing = this.createNewHearing();
        // should I use the data from local array or get it (latest?) from the DB??
        // set hearing date data for display
        this.myHearing.id = hearing.id;
        this.myDate = new Date(hearing.hearingDate);    // use this variable coz the calendar control needs a date
        this.myHearing.hearingDate = hearing.hearingDate;
        this.myHearing.hearingTime = hearing.hearingTime;
        //
        this.myHearing.boardNumber = hearing.boardNumber;
        this.myHearing.meetingLocationId = hearing.meetingLocationId;
        this.myHearing.meetingLocation = hearing.meetingLocation;
        this.myHearing.comment = hearing.comment;
        // the BoardMembers array was initialize by the createNewHearing method
        // now, replace the defaults with the ones already associated with the hearing...
        for (let i=0; i<hearing.boardMembers.length; i++) {
          this.myHearing.boardMembers[i] = hearing.boardMembers[i];
        }
        /*
        this.myHearing.boardMembers = hearing.boardMembers;
        for (let i=0; i<3; i++) {
            if (this.myHearing.boardMembers[i]==null) {
                this.myHearing.boardMembers.push({
                    id: 0,
                    memberName: '',
                });
            }
        }
         */
        //console.log(this.myHearing.boardMembers);
        //
        this.displayState.editHearingDiv = true;
        return true;
    }

    // triggered when user wants to define a new Hearing Date
    newHearing() {
        this.displayState.gridDiv = false;
        this.displayState.newHearingDiv = false;
        this.isNewEntry = true;
        this.displayState.editHearingDiv = true;
        this.myHearing = this.createNewHearing();
        this.myDate = null;
    }

    // save a Hearing Date
    saveHearing() {
        if (this.validateHearingData() === false) {
            this.showToast({ severity: 'error', detail: 'Required data is missing', summary: '' });
            return;
        }
        //console.log(this.myHearing);
        this.confirmationService.confirm({
            message: 'Do you want to save this Hearing Date?',
            header: 'Save Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.displayState.workingDiv = true;
                this.myHearing.hearingDate = this.myDate.toLocaleString();
                let myBoardMembers = [];
                for (let i=2;i>-1;i--) {
                    /* if (this.myHearing.boardMembers[i].id === 0) {
                        this.myHearing.boardMembers.splice(i, 1);
                    }*/
                    if (this.myHearing.boardMembers[i].id > 0) {
                        myBoardMembers.push(this.myHearing.boardMembers[i]);
                    }
                }
                // console.log('saving hearing date:');
                // clone the myHearing object so we can replace the boardmembers array w/o impacting the orig
                let hearingObj = Object.assign({}, this.myHearing);
                hearingObj.boardMembers = myBoardMembers;
                //console.log(this.myHearing.boardMembers);
                this.schedService.saveHearingDate(hearingObj).subscribe(data => {
                    //console.log('save returned: ' + data);
                    if (data == "-1") {
                        this.showToast({severity: 'error', detail: 'Problem saving Hearing Date', summary: ''})
                        this.displayState.workingDiv = false;
                    } else {
                        this.showToast({ severity: 'success', detail: 'Hearing Date saved!.', summary: '' });
                        this.getHearingDates();
                    }
                })
            },
            reject: () => {
                this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
            }
        });
    }

    // verify all required fields for a Hearing Date have been entered
    validateHearingData() {
        if ((!this.myDate) || (this.myHearing.hearingTime === '') || (this.myHearing.meetingLocationId < 1)) {
          return false;
        }
        return true;
    }

    cancelEntry() {
        this.displayState.newHearingDiv = true;
        this.displayState.editHearingDiv = false;
        this.displayState.gridDiv = true;
        return true;
    }

    // DELETE a Hearing Date; should we verify there are no cases already scheduled for this date??
    deleteHearing(hearing: IHearingDate) {
        //console.log('Delete HearingDate ID: ' + hearing.id + '; Date: ' + hearing.hearingDate);
        this.schedService.getScheduledCases(hearing.id.toString()).subscribe(data => {
            if (data.length) {
                this.showToast({ severity: 'error', detail: 'NOT ALLOWED - This Hearing has cases on its schedule', summary: ''});
                return;
            } else {
                this.confirmationService.confirm({
                    message: 'Do you want to DELETE this Hearing Date?',
                    header: 'Deleting Confirmation',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        this.displayState.workingDiv = true;
                        this.schedService.deleteHearingDate(hearing.id).subscribe(data => {
                            this.showToast({ severity: 'success', detail: 'Hearing Date DELETED!.', summary: '' });
                            this.getHearingDates();
                        });
                    },
                    reject: () => {
                        this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
                    }
                });
            }
        })
      }

      showToast(msg: Message) {
        this.messageService.add(msg);
      }

      clear() {
        this.messageService.clear();
      }

}
